import { render } from "./CheckupCard.vue?vue&type=template&id=2206cd9a&scoped=true"
import script from "./CheckupCard.vue?vue&type=script&lang=js"
export * from "./CheckupCard.vue?vue&type=script&lang=js"

import "./CheckupCard.vue?vue&type=style&index=0&id=2206cd9a&lang=scss&scoped=true"

import exportComponent from "/home/nodeapps/uzb/frontendBuild/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2206cd9a"]])

export default __exports__